const pagination = {
    page: 'Page',
    of: 'of',
    show: 'Show',
    showing: 'Showing',
    to: 'to',
    items: 'items',
    perPage: 'per page',
    perPageCount: '{{count}} per page',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
  };

export default pagination;
